<template>
    <main class="max-width-container with-backdrop">
        <BackdropImage :src="backdropUrl" />
        <h1 class="form-title">Edit location</h1>
        <LocationForm
            v-if="location"
            :initial-values="location"
            :back-link="`/trips/${tripId}`"
            :trip-id="tripId"
            :location="location"
            validated
            can-delete
            :errors="errors"
            @submit-form="submitForm"
            @delete="deleteLocation"
            @clear-error="clearError"
        />
    </main>
</template>

<script>
import LocationForm from "js/components/forms/LocationForm";
import BackdropImage from "js/components/common/BackdropImage";
import BaseFormWrapper from "js/components/base/BaseFormWrapper.js";
import { useTripStore } from "js/stores/tripStore";
import { useUtilsStore } from "js/stores/utilsStore";
import { useUserStore } from "js/stores/userStore";
import { usePageErrorStore } from "js/stores/pageErrorStore";
import { pageErrorFrom } from "js/lib/server.js";

export default {
    name: "LocationEdit",
    components: {
        LocationForm,
        BackdropImage,
    },
    extends: BaseFormWrapper,
    data() {
        return {
            id: undefined,
            tripId: undefined,
            store: undefined,
            userStore: undefined,
            location: null,
            tripImageUrl: null,
            errors: {},
        };
    },
    computed: {
        backdropUrl() {
            return this.location?.user_image_url ?? this.tripImageUrl;
        },
    },
    async mounted() {
        this.tripId = parseInt(this.$route.params.tripId);
        this.id = parseInt(this.$route.params.id);
        this.store = useTripStore();
        this.utilsStore = useUtilsStore();
        this.userStore = useUserStore();
        this.store
            .fetch(`/api/trips/${this.tripId}`)
            .then((trip) => {
                this.tripImageUrl = trip.user_image_url;
            })
            .catch(() => {});
        try {
            this.location = await this.store.fetch(
                `/api/trips/${this.tripId}/locations/${this.id}?with-companions`
            );
        } catch (err) {
            usePageErrorStore().set(pageErrorFrom(err));
        }
    },
    methods: {
        submitForm(data) {
            this.store
                .edit(
                    `/api/trips/${this.tripId}/locations/${this.id}`,
                    data,
                    !!data.user_image_file
                )
                .then(() => {
                    Promise.all([
                        this.store.refreshLocations(this.tripId),
                        this.userStore.refreshUser().catch(() => {}),
                    ]).then(() => {
                        this.$router.push(`/trips/${this.tripId}`);
                    });
                })
                .catch(this.handleResponseErrors);
            if (data.companions) {
                this.utilsStore.invalidate("companions");
            }
        },
        deleteLocation() {
            this.store
                .delete(`/api/trips/${this.tripId}/locations/${this.id}`)
                .then(() => {
                    this.store.refreshLocations(this.tripId).then(() => {
                        this.$router.push(`/trips/${this.tripId}`);
                    });
                });
        },
    },
};
</script>
